import { render, staticRenderFns } from "./EnvironmentCalculator.vue?vue&type=template&id=3868ab48&scoped=true"
import script from "./EnvironmentCalculator.vue?vue&type=script&lang=js"
export * from "./EnvironmentCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868ab48",
  null
  
)

export default component.exports